module.exports = __webpack_public_path__ + "static/img/image-not-available-3.b6f7b8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image-not-available-3.jpg
// module id = Y26b
// module chunks = 1